import { RemoteAudio } from '../JsSIP/interfaces';

// Single, long-lived <audio> sink for remote (in-call) audio, kept outside
// React so it survives component remounts. The SIP UserAgent captures the sink
// once at registration; on a React ref, a remount would null it and leave the
// call with a live stream but no output element (silent in-call audio).

let element: HTMLAudioElement | null = null;
let outputDeviceId = '';

export function getRemoteAudioElement(): HTMLAudioElement {
  if (!element) {
    element = document.createElement('audio');
    element.style.display = 'none';
    element.autoplay = true;
    element.setAttribute('playsinline', 'true');
    document.body.appendChild(element);
  }
  return element;
}

export function setRemoteOutputDeviceId(id: string): void {
  outputDeviceId = id;
}

export function getRemoteAudio(): RemoteAudio {
  return { audioElement: getRemoteAudioElement(), outputDeviceId };
}
